import { Component, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import {
  ControlsOf,
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
} from '@ngneat/reactive-forms';
import { addMinutes, format } from 'date-fns';
import { take } from 'rxjs/operators';

import { getUserName } from '@digital-platform/ries-hub-shared/domain';
import { NestedFormComponent } from '@digital-platform/shared/ui';
import { LoginSessionFacadeService } from '@digital-platform/users/services';
import {
  CommentLogHistory,
  WasteProfile,
} from '@digital-platform/waste-profiles/domain';

interface Comment {
  comment: string;
}

type CommentLog = WasteProfile['commentLog'];
@Component({
  selector: 'digital-platform-waste-profile-comment-log',
  templateUrl: './waste-profile-comment-log.component.html',
  styleUrls: ['./waste-profile-comment-log.component.scss'],
})
export class WasteProfileCommentLogComponent
  extends NestedFormComponent<CommentLog, Comment>
  implements OnInit, ControlValueAccessor<CommentLog>
{
  public form: FormGroup<ControlsOf<Comment>>;
  public dateFormat = 'M/d/yyyy h:mm a';
  commentLogs: CommentLog = [];
  comment: string;
  isDisabled = true;

  constructor(
    private formBuilder: FormBuilder,
    private facadeLoginSession: LoginSessionFacadeService,
    @Optional() @Self() public controlDir: NgControl
  ) {
    super(controlDir);
  }

  initializeForm() {
    this.commentLogs = this.value;
    this.form = this.formBuilder.group({
      comment: [''],
    });

    this.form.get('comment').valueChanges.subscribe((val) => {
      if (val) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    });
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  addComment() {
    const commentFormControl = this.form.get('comment');
    this.facadeLoginSession.loginSession$
      .pipe(take(1))
      .subscribe((loginSession) => {
        const { sub, email, emailVerified, title, phone, ext } =
          loginSession.user;
        const comment: CommentLogHistory = {
          date: new Date(
            format(
              addMinutes(new Date(), new Date().getTimezoneOffset()),
              'yyyy-MM-dd HH:mm:ss'
            )
          ),
          user: {
            sub,
            name: getUserName(loginSession.user),
            email,
            emailVerified,
            title,
            phone,
            ext,
          },
          comment: commentFormControl?.value,
        };

        this.commentLogs.push(comment);
        commentFormControl.reset();
      });
  }
}
